import { render, staticRenderFns } from "./Seo8.vue?vue&type=template&id=33eb82be&scoped=true&"
import script from "./Seo8.vue?vue&type=script&lang=js&"
export * from "./Seo8.vue?vue&type=script&lang=js&"
import style0 from "./Seo8.vue?vue&type=style&index=0&id=33eb82be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eb82be",
  null
  
)

export default component.exports